'use client';

import React from 'react';
import Drawer from '@mui/material/Drawer';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import NavLink from '@/components/layout-new/NavLink';
import SvgMenu from '@/components/layout-new/SvgMenu';

const Nav = () => {
  const [open, setOpen] = React.useState(false);

  const toggleDrawer = (newOpen: boolean) => () => {
    setOpen(newOpen);
  };

  return (
    <nav className="bg-white rounded-[10px] cursor-pointer">
      <div
        className="w-8 h-8 flex items-center justify-center"
        onClick={toggleDrawer(true)}
      >
        <SvgMenu />
      </div>
      <Drawer
        anchor="left"
        open={open}
        onClose={toggleDrawer(false)}
        disableScrollLock
        PaperProps={{
          className: 'bg-slate-50',
        }}
        ModalProps={{ slotProps: { backdrop: { className: '!bg-inherit' } } }}
      >
        <div className="px-[7px]">
          <div
            className="rounded-[10px] bg-white mt-4.5 w-8 h-8 flex items-center justify-center cursor-pointer mx-auto shadow-[0px_40px_80px_0px_#0000000D]"
            onClick={toggleDrawer(false)}
          >
            <CloseRoundedIcon />
          </div>
          <NavLink iconClassName="mb-1" />
        </div>
      </Drawer>
    </nav>
  );
};

export default Nav;
